import { Group, Stack, Switch, Text } from "@mantine/core"
import { Select, Badge } from "@tfg/ui"
import { Dispatch, SetStateAction, useEffect, useState } from "react"

import { FindIngestionSettingsResponseDto } from "~/gen/api"
import { useProductImportContext } from "~/pages/Admin/Ingestion/ProductImport/provider/ProductImportContext"

type Props = {
  selectedFile?: File | undefined
  ingestionSettings: FindIngestionSettingsResponseDto
  isBlankIngestion: boolean
  userEmail?: string
  mode: "import" | "verify"
  owner: string
  setOwner?: Dispatch<SetStateAction<string>>
  setIsBlankIngestion?: Dispatch<SetStateAction<boolean>>
}

export function IngestionSettings({
  selectedFile,
  ingestionSettings,
  isBlankIngestion,
  setIsBlankIngestion,
  mode,
  owner,
  setOwner,
}: Props) {
  const { owners } = useProductImportContext()

  const [ownersList, setOwnersList] = useState<string[]>(owners)

  useEffect(() => {
    setOwnersList(owners)
  }, [owners, ingestionSettings])

  return (
    <Group justify="flex-start" gap="md" align="flex-start">
      <Stack gap="md">
        <Select
          hidden
          w={350}
          label="Owner"
          value={owner}
          size="xs"
          error={selectedFile && !owner ? "Owner is required" : undefined}
          onChange={(value) => setOwner?.(value ?? "")}
          data={ownersList}
          disabled={mode === "import"}
        />
        <Stack>
          <Text fw="bold">Ingestion types</Text>
          <Badge
            text={`Traceability by ${ingestionSettings.traceabilityMethod.toLowerCase()}`}
            variant="info"
          />

          <Switch
            checked={isBlankIngestion}
            label="is Blank Ingestion"
            disabled={!setIsBlankIngestion}
            onChange={
              setIsBlankIngestion
                ? () => setIsBlankIngestion(!isBlankIngestion)
                : undefined
            }
          />
        </Stack>
      </Stack>

      <Stack>
        <Text fw="bold">Defaults standards</Text>
        <Group>
          {ingestionSettings.defaultStandards.length > 0 ? (
            ingestionSettings.defaultStandards.map((standard) => (
              <Badge key={standard} variant="info" text={standard} />
            ))
          ) : (
            <Badge variant="info" text="No default standards" />
          )}
        </Group>
        <Group />
      </Stack>
    </Group>
  )
}
